import { render } from "./allBadges.vue?vue&type=template&id=6364a7b1"
import script from "./allBadges.vue?vue&type=script&lang=js"
export * from "./allBadges.vue?vue&type=script&lang=js"

import "./allBadges.vue?vue&type=style&index=0&id=6364a7b1&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__